import { Account, PageableResponse, DataResponse, SalesforceAccount, composeQuery, Query } from '../models';
import { ceV2Axios, k1Axios, k1V2Axios } from './axios';

export const getAccounts = async (...criteria: Query<Account>[]) => (
  await k1V2Axios.get<PageableResponse<Account>>('/user-accounts', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<Account>(...criteria),
    data: {},
  })
).data;

export const checkPublicDomain = async (input: Required<Pick<Account, 'id'>>) => (
  await k1Axios.get<DataResponse<boolean>>(`/accounts/${input.id}/check-public-domain`)
).data.data;

export const getAccountsWithoutSubscriptions = async () => (
  await ceV2Axios.get<PageableResponse<Account>>('/accounts/empty', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    data: {},
  })
).data;

export const getAwsLinkedAccount = async () => (
  await ceV2Axios.get<DataResponse<Account>>('/accounts/aws-linked', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    data: {},
  })
).data.data;

export const getSalesforceLinkedAccount = async () => (
  await ceV2Axios.get<DataResponse<SalesforceAccount>>('/accounts/salesforce', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    data: {},
  })
).data.data;
